module.exports = __webpack_public_path__ + "media/application/images/svgs/phone-missed-87a0fb32bd2e60a9a9131e897bfd6ba6.svg";